"use client";

import { IVideoProps } from "@/lib/types/components";
import { useState } from "react";
import { Image } from "@template/components";

const VideoComponent = ({ src, fallbackImageSrc }: IVideoProps) => {
  const [loaded, setLoaded] = useState(true);

  return (
    <>
      {!loaded && (
        <Image
          src={fallbackImageSrc}
          alt="Fallback image"
          style={{
            width: "100%",
            height: "100%",
          }}
          width={400}
          height={400}
          quality={50}
        />
      )}
      <video
        autoPlay
        muted
        loop
        playsInline
        controls={false}
        style={{
          width: "100%",
          height: "100%",
          display: loaded ? "block" : "none",
        }}
        onErrorCapture={() => setLoaded(false)}
      >
        <source src={src} />
        Your browser does not support the video tag.
      </video>
    </>
  );
};

export default VideoComponent;
